import React from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import TableHead from "@mui/material/TableHead";

const useStyles = makeStyles({
  table: {},
});

const OrderAdyenRefunds = (props) => {
  const { adyenRefunds } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableCell colSpan="2">Refund Details</TableCell>
          </TableHead>
          <TableBody>
            {adyenRefunds &&
              adyenRefunds.length > 0 &&
              adyenRefunds.map((item) => (
                <>
                  <TableRow>
                    <TableCell>Refund Amount: </TableCell>
                    <TableCell align="left">
                      {item.amount && `$${(Number(item.amount) / 100).toFixed(2)}`}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Currency: </TableCell>
                    <TableCell align="left">{item.currency}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Result result: </TableCell>
                    <TableCell align="left">{item.success}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan="2"></TableCell>
                    
                  </TableRow>

                </>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default OrderAdyenRefunds;
